import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import { PERSONALIZATION_ENGINE } from './'
import {
  GetPersonalizationEngineResponse,
  GetPersonalizationEnginePayload,
} from '../models'

import { ActionTypes } from '../constants'

const restApiService: RestApiService = Container.get(RestApiService)

export const getAllPersonalizationEngineThunk = createAsyncThunk(
  ActionTypes.GET_ALL,
  async (payload: GetPersonalizationEnginePayload, thunkAPI) => {
    try {
      const {
        startDate,
        endDate,
        limit,
        page,
        transactionTypePayment,
        ...rest
      } = payload

      const transactionsDateRange = `${startDate}?${endDate}`

      restApiService.requestParams = {
        method: 'GET',
        endpoint:
          process.env.REACT_APP_STAGE === 'prod'
            ? PERSONALIZATION_ENGINE.GET_ALL_PROD
            : PERSONALIZATION_ENGINE.GET_ALL_DEV,
        externalServerURL:
          process.env && process.env.REACT_APP_SERVER_REPORTS_API,
        queries: jsonToQueryString({
          ...rest,
          limit: 999,
          transactionsDateRange,
        }),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: GetPersonalizationEngineResponse =
        await restApiService.getData(
          auth.brand.siteId.toString(),
          auth.token || '',
          process.env.REACT_APP_TOKEN_REPORTS,
        )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)
